import { create } from 'zustand';

import type { AddPrCommentType } from '../types/pr-comment-input';

type PullRequestCommentStore = {
  activePrCommentInput: AddPrCommentType | null;
  setActivePrCommentInput: (input: AddPrCommentType | null) => void;
};

export const usePrCommentInputStore = create<PullRequestCommentStore>((set) => ({
  activePrCommentInput: null,
  setActivePrCommentInput: (input) => set({ activePrCommentInput: input }),
}));
